<template>
  <div  class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <EnterpriseAdminSidebarMenu  :show_menu="false" :show_back_button="true" back_link="enterpriseadminreports"/>
      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper  center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <iframe id="pdf-frame" style="display: none;"></iframe>
          <div class="my-3"></div>
          <div>
            <div class="col-9 float-left text-left pl-0">
              <h3 class="d-inline heading text-uppercase">Competency Progress</h3>
            </div>
            <div class="col-3 float-right text-right pr-0" >
              <div class="margin-t-2 float-right pl-2" v-if="overviewLists.length > 0"  @click="shareButtonModal()">
                <img class="cursor-pointer" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" />
              </div>
              <div class="float-right pl-2 mr-2" v-if="overviewLists.length > 0">
                <i class="fa fa-print cursor-pointer" aria-hidden="true" @click="printFunc()" style="font-size: 30px; padding-top: 0px; "></i>
              </div>
              <div v-if="overviewLists.length > 0" class="margin-t-2 float-right pl-2 mr-2" @click="downloadFunc()">
                <img class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px"  />
              </div>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="border-bottom mt-1 mb-2"></div>
          <!-- Filter Section -->

        <div class="row"  v-if="loading == false">
          <div class="col-md-12 offset-md-0">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter</b-navbar-brand>
              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down "></i></b-navbar-toggle>
              <b-collapse id="nav-collapse" is-nav>
                <div class="search-wrapper col-12">
                  <div class="row col-12 override-padding pb-2 border-location">
                    <div class="col-3 pl-0">
                      <span class="cp-filter-label pr-2">Location:</span>
                      <b-form-select v-model="accountId" :options="report_all_locations" class="col-8 custom-select margin-bottom-10" style=" margin-top: 9px !important;" @change="updateAccountAction()" />
                    </div>
                    <div class="col-3 pl-0">
                      <span class="cp-filter-label pr-2">User:</span>
                      <b-form-select v-model="rep_mentee" :options="menteeLists" class="col-8 custom-select margin-bottom-10" style=" margin-top: 9px !important;" @change="updateMenteeTasklistAction()" />
                    </div>
                    <div class="col-3 p-0">
                      <span class="cp-filter-label pr-2">Pathways:</span>
                      <b-form-select v-model="rep_pathway" :options="pathwayLists"  @change="filterCompetency()" class="col-8 custom-select margin-bottom-10" style=" margin-top: 9px !important;" />
                    </div>
                    <div class="col-2 pr-0 text-right search-icon-wrapper cursor-pointer mt-1">
                      
                    </div>
                  </div>
                </div>
              </b-collapse>
            </b-navbar>
          </div>
        </div>

        <div class="clear"></div>





          <div class="row top-content" v-if="loading == true">
          <div class="col-3 p-0 pl-4" >
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3 pr-3">
            <div class="col-9" >
              <PuSkeleton  height="30px" :count="1"></PuSkeleton>
            </div>
          </div>
          </div>






          <div class="col-md-12 mb-2" v-for="option in 3" v-if="loading == true">
            <div class="col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3 margin-t-10">
              <div class="row row align-items-center">
                <div class="col-7">
                  <div class="cp-title col-4 text-left"><PuSkeleton :count="1" width=""></PuSkeleton></div>
                  <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
                  <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
                  <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
                  <div class="cp-text col-6"><PuSkeleton :count="1"></PuSkeleton></div>
                </div>
                <div class="col-5 pad-right"> 
                  <PuSkeleton circle height="120px" width="120px" :count="1"></PuSkeleton>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-11 mx-auto text-align-center margin-t-20" v-if="overviewLists.length == 0 && loading == false">
                  <i>No Records found</i>
              </div>
          </div>





          <div class="col-md-12 mb-2">
            <div class="col-12 mx-auto" v-for="(list, sindex) in overviewLists" :key="sindex">
              <div v-if="isOverviewVisible" class="col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3 margin-t-10">
                <div class="row cursor-pointer" @click="viewReportAction(list.accountId, list.menteeId)">
                  <div class="col-7 ml-4">
                    <div class="cp-title text-left"><b>{{ list.menteeName }}</b> - {{ list.accountName }}</div>
                    <div class="cp-text text-left">{{ list.tasklistsTitle }}</div>
                    <div class="cp-text padding-left-30">Total Tasks in List: {{ list.totalTaskCount }}</div>
                    <div class="cp-text padding-left-30">Total Tasks Competent: {{ list.totalCompetentTaskCount }}</div>
                    <div class="cp-text padding-left-30" >Total Time Submitted: {{ calchoursonly(list.totalTime) }}</div>
                    <div class="cp-text padding-left-30">
                    Remaining Tasks: {{ list.totalRemainingTaskCount }}
                    </div>
                  </div>
                  <div class="col-4 ml-4">                  
                    <vc-donut
                        background="white" foreground="grey"
                        :size="100" unit="px" :thickness="30"              
                        :sections="list.competent_percent" :total="100"
                        :start-angle="0" :auto-adjust-text-size="true" >
                    <h1>{{list.competent_percent[0].value}}%</h1>
                    </vc-donut>
                    <div class="view-report branding_text_color" @click="viewReportAction(list.accountId, list.menteeId)">View Report</div>
                    </div>
                  </div>
                </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>


        <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              :readOnly="isReadOnly" 
             />

    <ShareReportModal :isModalVisible="isShareModalVisible" @close="isShareModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading ml-1"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding success_msg">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control input-height-35"
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div class="clear margin-bottom-10"></div>


        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn col-3 input-height-25 ma-blue-btn"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey input-height-25 col-lg-3"
              ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>


    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import store from '../../store/store.js';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.use(Donut);

export default {
    data() {
        return {
            loading: false,
            taskLists: [],
            rep_task_list: '',
            rep_pathway: '',
            pathwayLists: [],
            menteeLists: [],
            rep_mentee: '',
            menteeId: '',
            taskListID: '',
            subtasks: [],
            rep_days: '',
            overviewTotalTaskCount: 0,
            overviewTotalCompetentTaskCount: 0,
            overviewTotalRemainingTaskCount: 0,
            overviewAllRemainingIds: [],
            chartDataItems: [],
            competentPercentValue: '',
            sections: [
                { label: 'Red section', value: 100, color: 'red' },
                { label: 'Green section', value: 0, color: 'green' }                
              ],
            headings: [],
            tasks: [],
            isOverviewRemainingModalVisible: false,
            isViewRemainingModalVisible: false,
            isReportViewTaskModalVisible: false,
            isOverviewVisible: true,
            accountId: '',
            isModalVisible: false,
            accountItems: [],
            report_all_locations: [],
            select_location: '',
            overviewLists: [],
            apiUrl: '',
            isShareModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            showOverlay: false,
            showWait: false,
            showShareSuccess: false,
            showOverlay: false,
        }
    },
    components: {
        UserMenu,
        GoBack,
        EnterpriseAdminSidebarMenu,
        EnterpriseAdminOverlaySidebar,
        ShareReportModal,
    },
    computed: {
      isReadOnly(){
        if (this.$store.state.enterprise_type === 'Readonly') {
          return true;
        } else {
          if (this.$store.state.switch_admin_enterprise_isreadonly) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    methods: {
        navigate(path) {
            router.push(path);
        },
        calchoursonly: function(minutes) {
            var hours = (minutes / 60);
            var rhours = Math.floor(hours);
            var min = (hours - rhours) * 60;
            var rminutes = Math.round(min);
            if(rminutes > 0) {
                return rhours + " Hours " + rminutes + " Minutes ";
            }
            else {
                return rhours + " Hours ";
            }
        },
        printFunc: function() {
          this.showOverlay = true;
          if (this.rep_mentee) {
              this.menteeId = this.rep_mentee;
          }
          if (this.rep_pathway) {
              this.pathwayID = this.rep_pathway;
          }
          axios.get('/desktop-report/overview-competency-report-pdf/' + this.pathwayID + '/' + this.menteeId + '/' + this.accountId, {
          })
          .then(res =>  {
            this.pdf_file_name = res.data.pdf_file_name;
            this.showOverlay = false;
            fetch(this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name).then(function(response) {
                return response.blob();
            }).then(function(myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function() {
                    window.setTimeout(function() {
                        document.querySelector('#pdf-frame').contentWindow.print();
                    }, 1000)
                });
              return false;
          })
          .catch(function(error) {
              console.log(error);
          });
        },

        shareButtonSubmit: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              this.submit_text = 'Please wait...';
              this.showWait = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_pathway) {
                this.pathwayID = this.rep_pathway;
            }
              axios('/user-overview-competency-report-email/' + this.pathwayID + '/' + this.menteeId + '/' + this.accountId,
                 {
                   method: 'POST',
                   data:
                    {
                      email: this.share_email,
                    },
                 }
               )
              .then((resp) => {
                this.share_email = '';
                this.submit_text = 'Submit';
                this.showWait = false;
                this.showShareSuccess = true;
                setTimeout(() => {
                    this.showShareSuccess = false;
                }, 5000)
                //this.isModalVisible = false;
                //this.$emit('close');

               })
              .catch(error => {

              });
            }
          });

        },
        shareButtonModal() {
          this.isShareModalVisible = true;
        },

        viewReportAction(accountId, menteeId) {
          router.push('/enterprise-admin/competency-report/' + accountId + '?mentee_id=' + menteeId + '&pathwayId=' + this.rep_pathway);
        },
        updateAccountAction() {
          this.getMenteesAction();
        },

        downloadFunc: function() {
            this.showOverlay = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_pathway) {
                this.pathwayID = this.rep_pathway;
            }
            axios.get('/desktop-report/overview-competency-report-pdf/' + this.pathwayID + '/' + this.menteeId + '/' + this.accountId, {
            })
            .then(response =>  {
                this.pdf_file_name = response.data.pdf_file_name;
                this.showOverlay = false;
                var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
     
                //Create XMLHTTP Request.
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "blob";
                req.onload = function () {
                    //Convert the Byte Data to BLOB object.
                    var blob = new Blob([req.response], { type: "application/octetstream" });
     
                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;
                    if (isIE) {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var url = window.URL || window.webkitURL;
                        var link = url.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("download", "competency_report.pdf");
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                };
                req.send();
                return false;
              })
              .catch(function(error) {
                  console.log(error);
              });


        },


        getMenteesAction() {
            this.menteeLists = [];
            axios.get('/enteprise-admin/account_mentees_list/' + this.accountId, {        
            })
            .then(response =>  {     
                var Lists = response.data;
                this.rep_mentee = 'All';
                this.menteeLists.push({
                'value': 'All',
                'text': 'All Users',
                });
                for(var i=0; i<Lists.length; i++) {
                  this.menteeLists.push({
                  'value': Lists[i].value,
                  'text': Lists[i].display
                  });
                }
                if(this.menteeLists.length > 0) {
                    this.overviewLists = [];
                    axios.get('/enterprise-admin/account_mentee_tasklists', {
                      params: {
                        account_id: this.accountId,
                        mentee_id: this.rep_mentee,
                      }
                    })
                    .then(response =>  {    
                      this.pathwayLists = [];
                      var Lists = response.data.pathwayLists;
                      for(var j=0; j<Lists.length; j++) {
                        this.pathwayLists.push({
                        'value': Lists[j].value,
                        'text': Lists[j].display
                        });
                      }
                      if(this.pathwayLists.length > 0) {
                        this.rep_pathway = this.pathwayLists[0].value;
                        this.filterCompetency();
                      }
                      else {
                        this.overviewLists = [];
                        this.loading = false;
                      }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });

                }
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        filterCompetency() {
            this.overviewLists = [];
            this.loading = true;
            if (this.rep_mentee) {
                this.menteeId = this.rep_mentee;
            }
            if (this.rep_pathway) {
                this.pathwayID = this.rep_pathway;
            }
            axios.get('/desktop-report/competency-overview/overview-tasks-lists/' + this.pathwayID + '/' + this.menteeId + '/' + this.accountId, {
            })
            .then(response =>  {
                this.loading = false; 
                // console.log(response)
                this.overviewLists = response.data.overview;
            })
            .catch(function(error) {
                console.log(error);
            });
        },

        updateMenteeTasklistAction: function() {           
            if(this.accountId != 'All') {
              router.push('/enterprise-admin/competency-report/' + this.accountId + '?mentee_id=' + this.rep_mentee);
            }
            else {
              axios.get('/enterprise-admin/get-account-from-mentee', {
                params: {
                    mentee_id: this.rep_mentee,
                }
              })
              .then(response =>  {    
                var account_id = response.data;
                router.push('/enterprise-admin/competency-report/' + account_id + '?mentee_id=' + this.rep_mentee);
              })
              .catch(error => {
                  console.log(error);
              });
            }
        },

        getRatedClass(count) {
            if (count > 2) {
                return 'cp-blue-reps';
            } else {
                return 'cp-gray-reps';
            }
        },
        getFontIcon(id) {
            if (document.getElementById('collapse-' + id).style.display == "") {
                document.getElementById('angle-'+ id).className = "fa fa-angle-down";
            } else {
                document.getElementById('angle-'+ id).className = "fa fa-angle-up";
            }
        },
        goToLocationWindow() {
          router.push('/enterprise-admin-dashboard');
        },
        closeSidebar() {
            this.isModalVisible = false;
        }
    },
    created: function () {
        this.loading = true;
        this.apiUrl = process.env.API_ENDPOINT;
        this.accountId = this.$route.params.accountId;
        axios('/enterprise-admin/getAllLinkedLocations',
        {
            method: 'GET'
        })
        .then(response => {
            var Lists = response.data.locations;
            // console.log(Lists);
            this.report_all_locations.push({
            'value': 'All',
            'text': 'All Locations',
            });
            for(var j=0; j<Lists.length; j++) {
              this.report_all_locations.push({
              'value': Lists[j].id,
              'text': Lists[j].company_name,
              });
            }
        })
        .catch(() => {
        });
        this.getMenteesAction();

    }
}
</script>
<style scoped>
.back-btn-wrapper {
    width:100%;
    margin-left: 10px;
    margin-right: 0px;
}
.cp-text {
    font-size: 14px;
    padding: 2px 0px 2px 0px;
}
.cp-title {
    font-size: 16px;
    font-weight: normal;
    padding: 5px 0px 0px 0px;
}
.subtask-list-layout {
    background-color: #FFF;
    border-radius: 10px;
    padding: 10px 0 10px 10px;
    margin-bottom: 10px
}
.subtask-list-layout h1 {
    font-size: 18px;
    text-align: center;
    vertical-align: middle;
    margin-top: 25px;
}
.report-line-separator {
    border-bottom: 1px solid #A6A6A6;
}  
.cp-toggle-icon {
    text-align: right;
    font-size: 26px;
    font-weight: bold;
    margin-right: 10px;
    margin-top: -2px;
}
.cp-heading-lists .row{
    margin-bottom: 10px;
}
.cp-heading-title {
    font-size: 14px;
    font-weight: 900;
    padding: 0;
}
.cp-blue-reps {
    color: #00acee;
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
}
.cp-gray-reps {
    color: #707070;
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
}
.cp-see-all-reps {
    color: #707070;
    text-align: right;
    padding-right: 70px;
    margin-bottom: 10px;
}
.cp-filter-label {
    font-weight: bold;
}
.cp-task-desc {
    padding:0 50px;
    margin-bottom: 10px;
}
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
h1 {
    color: #707070;
}
.rep_audit_bg {
    background-color: #FFF;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 10px;
}
.rep_heading {    
    font-size: 15px;
    font-weight: 900;
    margin-bottom: 10px;
}
.filterBtn {
    display: flex;
    margin: 0 auto;
}
.cp-filter-label {
    font-weight: bold;
    padding: 0px;
    margin: 0 5px;
    vertical-align: middle;
}
.circle {
  background-color: #2EACEE;  
  border-radius: 50%;
  height: 36px;
  width: 36px;
  text-align: center;
}
.circle i {
  color: #FFF;  
  font-size: 24px;
  text-align: center;
  padding-top: 5px;
  padding-right: 2px;
}
.container-wrapper .heading {
    font-size: 24px !important;
    font-weight: normal !important;
}
.rounded-pill {
    padding-left: 3rem!important;
    padding-right: 3rem!important;
}
.success_msg {
  color: #68C47E; text-align: center; margin-bottom: 15px;
}
.btn-dard-grey {
  border-radius: 15px;  
}
.padding-left-300 {
  padding-left: 300px;
}
.view-report {
  margin-top: 2px; color: #00ACEE; cursor: pointer; text-align: center;

}
.border-location {
  border-color: #ced4da;
}
.pad-right {
  text-align:right; 
  padding-right: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/competency_report_overview.vue